import React, { useCallback, useState } from "react";
import Layout from "../../components/UI/Layouts";
import Content from "../../components/UI/Layouts/Content";
import AuthContainer from "../../components/ScreenLogin/AuthContainer";
import { Redirect } from "react-router-dom";
import { useStores } from "../../hooks/useStores";
import { observer } from "mobx-react";
import { Alert } from "../../components/UI/Alert";
import { Container } from "../../styles";
import { getDividerUtilityClass } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

const LogIn: React.FC = observer(() => {
  const { t } = useTranslation();
  const { session } = useStores();
  const { enqueueSnackbar } = useSnackbar();

  const handleLogin = useCallback(
    async (email: string, password: string) => {
      await session
        .login(email, password)
        .then(() => {
          enqueueSnackbar(t("common.actionExecutedSuccessfully"), {
            variant: "success",
          });
        })
        .catch((err) => {
          enqueueSnackbar(err.message, {
            variant: "error",
          });
        });
    },
    [session]
  );

  if (session.isLogged) {
    return <Redirect to={"/"} />;
  }

  return (
    <Layout hideSidebar={true} hideFooter>
      <Content fullHeight>
        <AuthContainer handleLogin={handleLogin} />
      </Content>
    </Layout>
  );
});

export default LogIn;
